const SESSION_FIRST_FETCH_KEY = 'sessionFirstFetchDone';

const state = () => ({
  showAnimationLoading: false,
});

// mutations
const mutations = {
  setShowAnimationLoading(currentState, newValue) {
    currentState.showAnimationLoading = newValue;
  },
};

const actions = {
  setShowAnimationLoading({ commit }, payload) {
    if (!payload) {
      sessionStorage.setItem(SESSION_FIRST_FETCH_KEY, 'true');
      commit('setShowAnimationLoading', false);
      return;
    }
    if (sessionStorage.getItem(SESSION_FIRST_FETCH_KEY) === 'true') return;
    commit('setShowAnimationLoading', true);
  },
};

const getters = {
  showAnimationLoading: (s) => s.showAnimationLoading,
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};
